import React from 'react';
import { toast } from 'sonner';
import { Play } from 'lucide-react';
import { Panel, Disclaimer } from '../../components/Primitives';
import { api, errMsg } from '../../lib/api';

export default function AdminSettlements() {
  const run = async () => {
    try { const { data } = await api.post('/admin/settlements/run'); toast.success(`Settlement run — ${data.settled_accounts} account(s) posted`); }
    catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <div className="space-y-6" data-testid="admin-settlements">
      <Panel title="Daily Settlement Scheduler">
        <p className="text-sm text-vj-grey mb-4">Run the settlement process to reconcile paper-trading P&L, post settlement statements, and move settled funds to withdrawable balances for all eligible accounts.</p>
        <button onClick={run} className="h-11 px-6 rounded-lg bg-vj-neon text-vj-obsidian font-semibold text-sm inline-flex items-center gap-2 vj-glow-green hover:-translate-y-0.5 transition-all" data-testid="run-settlement-btn">
          <Play size={16} /> Run Settlement Now
        </button>
      </Panel>
      <Disclaimer>Settlements post auditable statements and never silently overwrite prior records. Corrections require audited reversal and replacement entries. Paper-trading results are labelled as Admin-Recorded / Paper trading data.</Disclaimer>
    </div>
  );
}
